﻿<eup-error-page statusCode="500"
				errorHeader="{{'Errors.Error_500_Title' | translate}}"
                errorDescription="{{'Errors.Error_500_Message' | translate }}">
</eup-error-page>